module.exports = __webpack_public_path__ + "img/Badge_Hipaa.23f17525.svg";